import React, { useMemo, useState } from "react";
import { Table } from "../../Components/Table/Table";
import { payrollDummyData, timeSheetDummyData } from "../../DummyData";
const Payroll = () => {

  const [pageno, setPageno] = useState(1);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");


  const data = useMemo(() => {
    return payrollDummyData.filter((item) =>
      item.month.toLowerCase().includes(search.toLowerCase()) ||
      item.pfnumber.toLowerCase().includes(search.toLowerCase()) ||
      item.uannumber.toLowerCase().includes(search.toLowerCase())
    );
  }, [search]);


  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        Cell: ({ row }) => (
          <span className={"classmate f1 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18"}>{row.index + 1}</span>
        ),
      },
      {
        Header: "Month",
        accessor: "month",
        Cell: ({ value }) => (
          <span className={"classmate f1 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18"}>{value}</span>
        ),
      },
      {
        Header: "PF Number",
        accessor: "pfnumber",
        Cell: ({ value }) => (
          <span className={"classmate f1 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18"}>{value}</span>
        ),
      },
      {
        Header: "UAN Number",
        accessor: "uannumber",
        Cell: ({ value }) => (
          <span className={"classmate f1 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18"}>{value}</span>
        ),
      },
      {
        Header: "Total Days",
        accessor: "totaldays",
        Cell: ({ value }) => (
          <span className={"classmate f1 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18"}>{value}</span>
        ),
      },
      {
        Header: "Days Worked",
        accessor: "daysworked",
        Cell: ({ value }) => (
          <span className={"classmate f1 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18"}>₹ {value}</span>
        ),
      },
      {
        Header: "Cross Salary",
        accessor: "crosssalary",
        Cell: ({ value }) => (
          <span className={"classmate f1 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18"}>₹ {value}</span>
        ),
      },
        {
        Header: "Deductions",
        accessor: "deductions",
        Cell: ({ value }) => (
          <span className={"classmate f1 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18"}>₹ {value}</span>
        ),
      },  {
        Header: "Net Payable",
        accessor: "netpayable",
        Cell: ({ value }) => (
          <span className={"classmate f1 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18"}>₹ {value}</span>
        ),
      },  {
        Header: "Action",
        accessor: "action",
        Cell: ({ value }) => (
          <span className={"classmate f1 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18"}>₹ {value}</span>
        ),
      },






    ],
    []
  );
  return (
    <div className="container">
      <h2 className="f2 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-12 fs-xl-14 fs-xxl-18 my-3">Employee Salary Details</h2>


      <div className="d-flex gap-2 mb-3">
        <input
          type="text"
          className="form-control w-25"
          placeholder="Search by name or email"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      
      </div>

      <Table
        columns={columns}
        data={data}
        pageno={pageno}
        setPageno={setPageno}
        show={true}
      />
    </div>
  )
}
export default Payroll
